import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch, getUserFacingErrorMessage } from './services/apiClient';
import './SupportPages.css';

function formatStatus(status) {
  return String(status || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function SupportTicketsPage() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch('/api/support-tickets');
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(
          getUserFacingErrorMessage(res.status, data, data.detail || 'Failed to load tickets')
        );
      }
      setTickets(Array.isArray(data.tickets) ? data.tickets : []);
    } catch (err) {
      setError(err.message || 'Failed to load tickets');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="support-page">
      <div className="support-header">
        <div>
          <p className="support-eyebrow">Help &amp; Support</p>
          <h1>My tickets</h1>
        </div>
        <Link to="/support/new" className="support-btn">
          New ticket
        </Link>
      </div>

      <div className="glass-container support-card">
        {error && <div className="support-error">{error}</div>}
        {loading ? (
          <p className="support-empty">Loading…</p>
        ) : tickets.length === 0 ? (
          <p className="support-empty">
            No tickets yet.{' '}
            <Link to="/support/new">Raise a support ticket</Link> if you need help.
          </p>
        ) : (
          <ul className="support-ticket-list">
            {tickets.map((t) => (
              <li key={t.id}>
                <Link
                  to={`/support/${encodeURIComponent(t.public_id || t.id)}`}
                  className="support-ticket-row"
                >
                  <div className="support-ticket-row-top">
                    <span className="support-ticket-id">{t.public_id}</span>
                    <span className="support-ticket-subject">{t.subject}</span>
                    <span className={`support-badge status-${t.status}`}>
                      {formatStatus(t.status)}
                    </span>
                  </div>
                  <p className="support-ticket-meta">
                    {t.category} · {t.priority}
                    {t.updated_at ? ` · Updated ${new Date(t.updated_at).toLocaleString()}` : ''}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default SupportTicketsPage;
